﻿package com.mgacreative.hotelru.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class PosOrder(
    val id: String,
    val tenant_id: String,
    val table_name: String,
    val status: String,
    val total_amount: Double,
    val reservation_id: String? = null,
    val created_at: String,
    val updated_at: String
)

@Serializable
data class CreatePosOrderRequest(
    val tenant_id: String,
    val table_name: String,
    val status: String,
    val total_amount: Double,
    val reservation_id: String? = null
)

